import { ApiResponse } from '@/models/ApiResponse';
import { ReportFile } from '@/models/ReportFile';
import { GenericResponse } from '@/types/downloadReports';

import { createAsyncAction } from 'typesafe-actions';

export const saveUserWidgetDealContingentActions = createAsyncAction(
  'DEAL_CONTINGENT/saveUserWidgetDealContingent/request',
  'DEAL_CONTINGENT/saveUserWidgetDealContingent/success',
  'DEAL_CONTINGENT/saveUserWidgetDealContingent/failure',
)<void, GenericResponse, string>();

export const runDealContingentActions = createAsyncAction(
  'DEAL_CONTINGENT/runDealContingent/request',
  'DEAL_CONTINGENT/runDealContingent/success',
  'DEAL_CONTINGENT/runDealContingent/failure',
)<void, ApiResponse<ReportFile>, string>();

/**
 * The rates report gets its own request state rather than sharing the FX one:
 * both reports have a download button on the Deal Contingent Analysis page, and
 * a shared flag would spin both. The success payload is the same download
 * envelope, so the reducer hands it to the same helper.
 */
export const runRatesDealContingentActions = createAsyncAction(
  'DEAL_CONTINGENT/runRatesDealContingent/request',
  'DEAL_CONTINGENT/runRatesDealContingent/success',
  'DEAL_CONTINGENT/runRatesDealContingent/failure',
)<void, ApiResponse<ReportFile>, string>();
